import { render, staticRenderFns } from "./regra-de-cupons.vue?vue&type=template&id=5f1f4f63&"
import script from "./regra-de-cupons.vue?vue&type=script&lang=js&"
export * from "./regra-de-cupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports